import { render, staticRenderFns } from "./AppBanner.vue?vue&type=template&id=c5744108&scoped=true&"
import script from "./AppBanner.vue?vue&type=script&lang=js&"
export * from "./AppBanner.vue?vue&type=script&lang=js&"
import style0 from "./AppBanner.vue?vue&type=style&index=0&id=c5744108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5744108",
  null
  
)

export default component.exports